// extracted by mini-css-extract-plugin
export var container = "Button-module--container--7gmhv";
export var outline = "Button-module--outline--c0xrP";
export var remove = "Button-module--remove--q9WKM";